import type { FunctionComponent } from 'react';
import CombinationDialog from '../../components/organisms/CombinationDialog';
import type { Concept } from '../../data/Concepts';
import type { Combination } from '../../data/Combinations';

export interface StateProps {
	combination?: Combination;
}

export interface DispatchProps {}

export interface OwnProps {
	concept: Concept;
	onNext: (concept: Concept) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

const CombinationScreen: FunctionComponent<Props> = (props: Props) => {
	const { concept, combination, onNext } = props;

	return combination ? (
		<CombinationDialog
			concept={concept}
			combination={combination}
			onNext={onNext}
		/>
	) : (
		<div>No combination</div>
	);
};

export default CombinationScreen;
